import template from 'contentful/shoppable/shoppable-product-component.j2';

import { generate } from '@core/js/utils/componentUtils';
import { defaultQuickshopOptions } from '@core/js/utils/defaultQuickshopOptions';
import { getDefaultOptions } from '@core/js/utils/a15componentUtils';
import { launchAsyncQuickshop } from '@product/js/utils/asyncLaunchers';
import { createGAEvent } from '../../../core/js/utils/analyticsUtils';
import { handleUtagEvent } from '../../../core/js/actions/initialActions';

import queryString from 'query-string';

/**
 * Get query params for shoppable product quickshop
 * @param  {Object} $target jquery object of current target
 * @return {Object} object containing slug and color
 */
function getParamsForQuickShop($target) {
    const slug = $target.attr('data-shoppable-product-slug');
    const color = $target.attr('data-shoppable-product-color');

    return {
        slug: slug ? slug : "",
        color: color ? color : ""
    };
}

/**
 * Launch shoppable product quickshop
 * @param  {Object} event jquery event
 * @param  {Object} store The redux store
 */
function launchShoppableQuickShop(event, store) {
    const $target = $(event.currentTarget);
    const concatQueryString = queryString.stringify(getParamsForQuickShop($target));

    launchAsyncQuickshop(store, defaultQuickshopOptions, event, [{
        product: {
            queryParams: concatQueryString
        }
    }]);
}

export function attachEvents(store) {
    const isTouchDevice = _.get(this.getDeviceCharacteristics(), 'is_touch', false);

    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-launch-shoppable-quickshop'), (e) => {
        e.preventDefault();
        const $target = $(e.currentTarget);
        const $shoppableProduct = $target.parents('.dom-shoppable-product');
        const dotsAreVisible = $shoppableProduct.hasClass("c-shoppable-image__show-dots");

        // UW-16088 Shopitorial - don't launch quickshop on initial Touchscreen tap
        // Prevent randomly tapping on mobile device and triggering quickshop
        if (isTouchDevice && !dotsAreVisible) { return; }

        // Blur the current dot so it doesn't stay active after quickshop's closed UW-15844
        $target.blur();

        // Safari hangs onto focus on a higher element so it has to be blurred explicitly UW-15454
        // eslint-disable-next-line newline-per-chained-call
        $target.parents('.c-shoppable-image__outer').blur();

        launchShoppableQuickShop(e, store);
    });

    /**
     * Add functionality to toggle display of dots by touch
     * use click to avoid this event firing on scroll on touch devices
    */
    if (isTouchDevice) {
        $(document).on(this.scopedEvent('click'), this.scopedSelector(), (e) => {
            const shoppableProduct = $(e.currentTarget);
            const dotVisiblityClass = "c-shoppable-image__show-dots";
            const gaEvent = createGAEvent('PAGE_TYPE', 'shopitorial tap', '');

            if (shoppableProduct.hasClass(dotVisiblityClass)) {
                // Hide the dots here
                shoppableProduct.removeClass(dotVisiblityClass);
            } else {
                // Show the dots again and add ga event
                shoppableProduct.addClass(dotVisiblityClass);
                store.dispatch(handleUtagEvent(gaEvent, 'link'));
            }
        });
    }

    // Clicking outside of the shoppable product should hide the dots
    $(document).on('click', (e) => {
        const $shoppableProduct = $('.dom-shoppable-product');
        if(!$(e.target).closest('.dom-shoppable-product').length) {
            if($shoppableProduct.hasClass('c-shoppable-image__show-dots')) {
                $shoppableProduct.removeClass('c-shoppable-image__show-dots');
            }
        }
    });
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-shoppable-product',
        template: template,
        name: 'shoppableProductComponent',
        attachEvents: attachEvents
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
